import React, { Component } from 'react';

import PropTypes from 'prop-types';

import getFirstName from 'common/util/getFirstName';

function getStatus(post) {
  const { status } = post;
  var words = status.split(' ');
  for (var i = 0; i < words.length; i++) {
    var word = words[i];
    word = word.charAt(0).toUpperCase() + word.substr(1);
    words[i] = word;
  }
  return words.join(' ');
}

export default {
  'commentCreated.boardMember': class extends Component {
    static propTypes = {
      notification: PropTypes.object.isRequired,
    };

    render() {
      const { notification } = this.props;
      return (
        <span>
          {getFirstName(notification.comment.author.name)}
          {' commented on a post in '}
          {notification.comment.post.board.name}
          {', '}
          {notification.comment.post.title}
        </span>
      );
    }
  },

  'commentCreated.otherCommenter': class extends Component {
    static propTypes = {
      notification: PropTypes.object.isRequired,
    };

    render() {
      const { notification } = this.props;
      return (
        <span>
          {getFirstName(notification.comment.author.name)}
          {' also commented on a post, '}
          {notification.comment.post.title}
        </span>
      );
    }
  },

  'commentCreated.parentAuthor': class extends Component {
    static propTypes = {
      notification: PropTypes.object.isRequired,
    };

    render() {
      const { notification } = this.props;
      return (
        <span>
          {getFirstName(notification.comment.author.name)}
          {' replied to your comment on '}
          {notification.comment.post.title}
        </span>
      );
    }
  },

  'commentCreated.postAuthor': class extends Component {
    static propTypes = {
      notification: PropTypes.object.isRequired,
    };

    render() {
      const { notification } = this.props;
      return (
        <span>
          {getFirstName(notification.comment.author.name)}
          {' commented on your post, '}
          {notification.comment.post.title}
        </span>
      );
    }
  },

  'postCreated.boardMember': class extends Component {
    static propTypes = {
      notification: PropTypes.object.isRequired,
    };

    render() {
      const { notification } = this.props;
      if (notification.post.author) {
        return (
          <span>
            {getFirstName(notification.post.author.name)}
            {' created a post in '}
            {notification.post.board.name}
            {', '}
            {notification.post.title}
          </span>
        );
      } else {
        return (
          <span>
            {'A new post was created in '}
            {notification.post.board.name}
            {', '}
            {notification.post.title}
          </span>
        );
      }
    }
  },

  'postMerged.postAuthor': class extends Component {
    static propTypes = {
      notification: PropTypes.object.isRequired,
    };

    render() {
      const { notification } = this.props;
      return (
        <span>
          {'Your post has been merged into '}
          {notification.post.title}
        </span>
      );
    }
  },

  'postOwnerChanged.oldPostOwner': class extends Component {
    static propTypes = {
      notification: PropTypes.object.isRequired,
    };

    render() {
      const { notification } = this.props;
      const { post } = notification;

      return (
        <span>
          {getFirstName(post.ownerAssigner.name)}
          {' changed the owner of '}
          {post.title}
          {' from you to '}
          {getFirstName(post.owner.name)}
        </span>
      );
    }
  },

  'postOwnerChanged.postOwner': class extends Component {
    static propTypes = {
      notification: PropTypes.object.isRequired,
    };

    render() {
      const { notification } = this.props;
      const { post } = notification;
      return (
        <span>
          {getFirstName(post.ownerAssigner.name)}
          {' made you the owner of '}
          {post.title}
        </span>
      );
    }
  },

  'postOwnerCleared.oldPostOwner': class extends Component {
    static propTypes = {
      notification: PropTypes.object.isRequired,
    };

    render() {
      const { notification } = this.props;
      const { post } = notification;
      return (
        <span>
          {getFirstName(post.ownerAssigner.name)}
          {' removed you as the owner of '}
          {post.title}
        </span>
      );
    }
  },

  'postStatusChanged.boardMember': class extends Component {
    static propTypes = {
      notification: PropTypes.object.isRequired,
    };

    render() {
      const { notification } = this.props;
      return (
        <span>
          {notification.post.title}
          {' in '}
          {notification.post.board.name}
          {' has been marked as '}
          {getStatus(notification.post)}
        </span>
      );
    }
  },

  'postStatusChanged.commenter': class extends Component {
    static propTypes = {
      notification: PropTypes.object.isRequired,
    };

    render() {
      const { notification } = this.props;
      return (
        <span>
          {'A post you commented on, '}
          {notification.post.title}
          {', has been marked as '}
          {getStatus(notification.post)}
        </span>
      );
    }
  },

  'postStatusChanged.postAuthor': class extends Component {
    static propTypes = {
      notification: PropTypes.object.isRequired,
    };

    render() {
      const { notification } = this.props;
      return (
        <span>
          {'Your post, '}
          {notification.post.title}
          {', has been marked as '}
          {getStatus(notification.post)}
        </span>
      );
    }
  },

  'postStatusChanged.voter': class extends Component {
    static propTypes = {
      notification: PropTypes.object.isRequired,
    };

    render() {
      const { notification } = this.props;
      return (
        <span>
          {'A post you voted on, '}
          {notification.post.title}
          {', has been marked as '}
          {getStatus(notification.post)}
        </span>
      );
    }
  },

  'userMentioned.mentionedUser': class extends Component {
    static propTypes = {
      notification: PropTypes.object.isRequired,
    };

    render() {
      const { notification } = this.props;
      return (
        <span>
          {getFirstName(notification.comment.author.name)}
          {' mentioned you in '}
          {notification.comment.post.title}
        </span>
      );
    }
  },

  'voteMilestone.boardMember': class extends Component {
    static propTypes = {
      notification: PropTypes.object.isRequired,
    };

    render() {
      const { notification } = this.props;
      return (
        <span>
          {notification.voteMilestone}
          {' people voted on a post in '}
          {notification.post.board.name}
          {', '}
          {notification.post.title}
        </span>
      );
    }
  },

  'voteMilestone.postAuthor': class extends Component {
    static propTypes = {
      notification: PropTypes.object.isRequired,
    };

    render() {
      const { notification } = this.props;
      return (
        <span>
          {notification.voteMilestone}
          {' people voted on a post, '}
          {notification.post.title}
        </span>
      );
    }
  },
};
